import { Mui } from "@osu/react-ui";
import Paper from "../Paper";
import SystemMessageForm from "./Form";

const id = "system-message";
const headingId = id + "-heading";

function SystemMessage() {
  return (
    <Paper>
      <Mui.Typography id={headingId} sx={{ paddingBottom: 2 }} variant="h2">
        Manage System Alert
      </Mui.Typography>
      <SystemMessageForm
        display="flex"
        flexDirection="column"
        alignItems="flex-start"
        aria-labelledby={headingId}
      ></SystemMessageForm>
    </Paper>
  );
}

export default SystemMessage;
